import { render, staticRenderFns } from "./orderListInfo.vue?vue&type=template&id=63abc5c8&scoped=true"
import script from "./orderListInfo.vue?vue&type=script&lang=js"
export * from "./orderListInfo.vue?vue&type=script&lang=js"
import style0 from "./orderListInfo.vue?vue&type=style&index=0&id=63abc5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63abc5c8",
  null
  
)

export default component.exports